export const getStoreById = `query getStoresByIds($merchantId: String) {
  uiShopping {
    stores(input: { storeIds: [$merchantId] }) {  
      stores {
        itemId
        itemType
        title
        description
        landingUrl
        storeIds
        primaryImage {
          ...ImageFragment
        }
        rewardsPointsLabel
        rewardsPointsSubtitle
        secondaryImage {
          ...ImageFragment
        }
        termsAndConditionsSection {
          title
          content
        }
        storeDescription
        averageSavings30d {
          ...ItemContentFragment
        }
        freeShipping {
          ...ItemContentFragment
        }
        freeReturn {
          ...ItemContentFragment
        }
        payInFourPayments {
          ...ItemContentFragment
        }
        cashBackRewards {
          title
          content
        }
        honeyDeals {
          ...HoneyOfferFragment
        }
        honeyCoupons {
          ...HoneyOfferFragment
          customRedemptionCode
        }
        paypalMerchantOffersSection {
          title
          offers {
            itemId
            itemType
            rank
            title
            description
            storeIds
            primaryImage {
              ...ImageFragment	
            }	
            actions {	
              ...ActionsFragment	
            }	
            tags {	
              text	
              type	
            }	
          }	
        }
        defaultCouponTerms {
          title
          content
        }
        totalHoneyOffers
        totalHoneyCoupons
        totalHoneyDeals
        actions {
          ...ActionsFragment
        }
      }
    }
  }
}

fragment ImageFragment on UI_Shopping_Image {
  accessibilityLabel
  url
  name
  backgroundColor
  imageSize
}


fragment ActionsFragment on UI_Shopping_Action {
  type
  title
  navigationType
  navigationTarget
  modalContent {
    title
    description
    primaryImage {
      url
      accessibilityLabel
    }
    modalSections {
      title
      description
    }
    actions {
      type
      title
      navigationType
      navigationTarget    
    }
  }
}

fragment HoneyOfferFragment on UI_Shopping_HoneyOffer {
  honeyOfferId
  honeyOfferType
  rank
  title
  subtitle
  description
  storeIds
  primaryImage {
    ...ImageFragment
  }
  actions {
    ...ActionsFragment
  }
  tags {
    text
    type
  }
}


fragment ItemContentFragment on UI_Shopping_ItemContent {
  title
  content
  icon {
    name
    url
  }
}
`
